import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { ADD_PACKAGE_PERMISSION, DELETE_PACKAGE_PERMISSION, GET_PACKAGE_PERMISSIONS, UPDATE_PACKAGE_PERMISSION, UPDATE_PACKAGE_PERMISSION_STATUS } from "../types";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const addPackagePermission = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("package/permission/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_PACKAGE_PERMISSION, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);  
        Swal.fire({
          title: 'warning!',
          text: res.data.message,
          icon: 'warning',
      });
    }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // const errorMessage =
    //   err.response?.data?.message || "An unexpected error occurred";
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
export const getPackagePermission = () => async (dispatch) => {
  try {
    const res = await axios.get("package/permission/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_PACKAGE_PERMISSIONS, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};


export const updatePackagePermission = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.name && { name: formData.name }),
      ...(formData.pId && { pId: formData.pId }),
      ...(formData.prIds && { prIds: formData.prIds }),
      // ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("package/permission/update", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_PACKAGE_PERMISSION, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updatePackagePermissionStatus = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.name && { name: formData.name }),
      ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("package/permission/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_PACKAGE_PERMISSION_STATUS, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deletePackagePermission = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`package/permission/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_PACKAGE_PERMISSION, payload: { id } });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
